export class AC101EnquiryModalContent extends HTMLElement {
    get endpoint() {
        return this.getAttribute("endpoint");
    }

    get gotoStepTwoButton() {
        return this.querySelector<HTMLButtonElement>('button[data-step="2"]');
    }

    get submitButton() {
        return this.querySelector<HTMLButtonElement>("button[data-submit]");
    }

    get stepOneContent() {
        return this.querySelector<HTMLElement>('div[data-step="1"]');
    }

    get stepTwoContent() {
        return this.querySelector<HTMLElement>('div[data-step="2"]');
    }

    get stepThreeContent() {
        return this.querySelector<HTMLElement>('div[data-step="3"]');
    }

    get profileSelect() {
        return this.querySelector<HTMLSelectElement>("select[data-profile]");
    }

    get behalfOfName() {
        return this.querySelectorAll<HTMLElement>("[data-behalf-of-name]");
    }

    get behalfOfCreatedOn() {
        return this.querySelector<HTMLElement>("[data-behalf-of-created-on]");
    } 

    gotoStepOne() {
        this.stepOneContent.style.display = "block";
        this.stepTwoContent.style.display = "none";
        this.stepThreeContent.style.display = "none";
    }

    gotoStepTwo() {
        this.stepOneContent.style.display = "none";
        this.stepTwoContent.style.display = "block";
        this.stepThreeContent.style.display = "none";
    }

    gotoStepThree() {
        this.stepOneContent.style.display = "none";
        this.stepTwoContent.style.display = "none";
        this.stepThreeContent.style.display = "block";
    }

    async submit() {
        this.submitButton.disabled = true;
        const data = new FormData(this.querySelector<HTMLFormElement>("form"));

        const response = await fetch(this.endpoint, {
            method: "post",
            body: data,
        });

        if (response.ok) {
            this.gotoStepThree();
        }

        this.submitButton.disabled = false;
    }

    connectedCallback() {
        this.addEventListener("show.bs.modal", () => this.gotoStepOne());

        this.gotoStepOne();
        this.gotoStepTwoButton.addEventListener("click", () => this.gotoStepTwo());
        this.submitButton.addEventListener("click", () => this.submit());

        if (!this.profileSelect) return; //we may not have a profile select

        this.profileSelect.addEventListener("change", (e: Event) => {
            const element = e.target as HTMLSelectElement;
            for (const option of element.selectedOptions) {
                const firstName = option.getAttribute("data-first-name");
                const createdOn = option.getAttribute("data-created-on");

                for (const behalf of this.behalfOfName) {
                    behalf.innerText = firstName;
                }
                this.behalfOfCreatedOn.innerText = createdOn;
            }
        });
        this.profileSelect.dispatchEvent(new Event('change'));

        
    }
}

customElements.define("ac101-enquiry-modal-content", AC101EnquiryModalContent);